import U from '../js/utils';
export default async (heading, msg) => {
  // Ensure heading and msg are strings
  const safeHeading = typeof heading === 'string' ? heading : (heading ? String(heading) : 'Error');
  let safeMsg;
  
  if (typeof msg === 'string') {
    safeMsg = msg;
  } else if (msg === null || msg === undefined) {
    safeMsg = 'An error occurred. Please try again.';
  } else if (typeof msg === 'object') {
    // Try to extract a meaningful message from the object
    if (msg.message && typeof msg.message === 'string') {
      safeMsg = msg.message;
    } else if (msg.error && typeof msg.error === 'string') {
      safeMsg = msg.error;
    } else {
      try {
        safeMsg = JSON.stringify(msg);
      } catch (e) {
        safeMsg = String(msg);
      }
    }
  } else {
    safeMsg = String(msg);
  }

  const div = `
    <div
      id="errorBox"
      class="fixed inset-0 z-50 overflow-y-auto bg-opacity-50 bg-black "
    >
      <div
        class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
      >
        <div
          class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
        >
          <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h4 id="modal-title">
                ${safeHeading}
                </h4>
                <div class="mt-2">
                  <p id="modal-msg">
                  ${safeMsg}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg-gray-50 px-4 py-3 flex md:justify-end justify-center sm:px-6"
          >
          
            <button id="modal-btn"  onclick="U.closeModal('errorBox')">Okay</button>
          </div>
        </div>
      </div>
    </div>

     `;

  const modal = U.createHTMLElementFromString(div);
  document.body.prepend(modal);
};
